import { useEffect } from "react";
import { createTimeline } from "animejs";

export const Home = () => {
    const socialLinkStyle =
        "social-item text-[#8BA08E] hover:text-black transition-colors duration-200 opacity-0";
    const navLinkStyle =
        "nav-item text-2xl text-zinc-800 hover:opacity-60 transition-opacity opacity-0 block";

    useEffect(() => {
        const timeline = createTimeline({
            defaults: {
                ease: "outExpo",
            },
        });

        timeline
            .add(".header-title", {
                translateY: [40, 0],
                opacity: [0, 1],
                duration: 1200,
                delay: 200,
            })
            .add(
                ".section-title",
                {
                    translateY: [20, 0],
                    opacity: [0, 1],
                    duration: 800,
                },
                "-=600",
            )
            .add(
                ".animate-p",
                {
                    translateY: [20, 0],
                    opacity: [0, 1],
                    duration: 800,
                    delay: (el, i) => i * 150,
                },
                "-=600",
            )
            .add(
                ".social-item, .social-divider",
                {
                    translateY: [10, 0],
                    opacity: [0, 1],
                    duration: 600,
                    delay: (el, i) => i * 50,
                },
                "-=400",
            )
            .add(
                ".nav-item",
                {
                    translateY: [20, 0],
                    opacity: [0, 1],
                    duration: 800,
                    delay: (el, i) => i * 100,
                },
                "-=400",
            )
            .add(
                ".footer-text",
                {
                    opacity: [0, 1],
                    duration: 1000,
                },
                "-=600",
            );
    }, []);

    return (
        <div className="min-h-screen text-zinc-800 selection:bg-[#E5E0DA]">
            <header className="py-12 text-center">
                <h1 className="header-title text-5xl font-melodrama tracking-widest opacity-0">
                    CHRISTIAN JACOB
                </h1>
            </header>

            <main className="max-w-4xl mx-auto px-8">
                <section className="mb-8">
                    <h2 className="section-title text-xl font-medium mb-4 font-melodrama opacity-0">
                        Hello there! 👋🏽
                    </h2>

                    <div className="space-y-6 text-[15px] leading-relaxed text-justify text-zinc-700">
                        <p className="animate-p opacity-0">
                            I'm Jacob but most people call me Christian. I’m a
                            compliance professional who builds and operates
                            safety nets that allow financial companies to scale
                            while keeping regulators happy. From audit-ready
                            compliance programs to smoother user onboarding, I
                            help regulated businesses grow while keeping safety
                            front and center.
                        </p>

                        <p className="animate-p opacity-0">
                            In my day-to-day, I’m building{" "}
                            <a
                                href="https://useverify.co"
                                target="_blank"
                                rel="noreferrer"
                                className=" text-green font-medium underline-offset-4 decoration-zinc-300 hover:decoration-zinc-800 transition-all"
                            >
                                Vrfy
                            </a>
                            , a privacy-first RegTech platform that detects
                            falsified or manipulated documents using a two-layer
                            analysis engine. It enables small businesses and
                            high-volume verification teams to authenticate
                            documents in seconds, without downloads, uploads, or
                            workflow interruptions.
                        </p>

                        <p className="animate-p opacity-0">
                            Outside of work, I’m a semi-retired writer who
                            dabbles in photography from time to time. When I’m
                            not working, you’ll usually find me hunting for
                            indie gems or the latest blockbuster at the cinema,
                            playing tennis, wrestling with my saxophone,
                            reading, or sending Instagram Reels to friends—my
                            preferred form of inescapable brain rot.
                        </p>

                        <p className="animate-p opacity-0">
                            I’m always open to meeting thoughtful, creative
                            people who enjoy building interesting things. If
                            something here resonates, feel free to reach{" "}
                            <a
                                href="mailto:chegbe.christian@gmail.com"
                                className="underline underline-offset-4 decoration-zinc-300 hover:decoration-zinc-800"
                            >
                                out
                            </a>
                            .
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-x-4 gap-y-2 my-6 pb-6  border-zinc-200 text-sm font-medium">
                        <a
                            href="https://www.linkedin.com/in/thechristianjacob/"
                            target="_blank"
                            rel="noreferrer"
                            className={socialLinkStyle}
                        >
                            LinkedIn
                        </a>
                        <span className="social-divider text-zinc-300 opacity-0">
                            |
                        </span>
                        <a
                            href="https://www.instagram.com/itschristianjacob/"
                            target="_blank"
                            rel="noreferrer"
                            className={socialLinkStyle}
                        >
                            Instagram
                        </a>
                        <span className="social-divider text-zinc-300 opacity-0">
                            |
                        </span>
                        <a
                            href="https://x.com/thisischegbe"
                            target="_blank"
                            rel="noreferrer"
                            className={socialLinkStyle}
                        >
                            Twitter
                        </a>
                    </div>
                </section>

                <nav className="md:grid grid-cols-3 font-melodrama md:gap-8 pb-10 text-center">
                    <div className=" md:space-y-4">
                        <a
                            href="https://medium.com/@chegbe.christian"
                            target="_blank"
                            rel="noreferrer"
                            className={navLinkStyle}
                        >
                            Blog
                        </a>
                    </div>
                    <div className=" md:space-y-4">
                        <a
                            href="https://www.notion.so/Publications-2d541ba986568098aab6c9cd37a77ebf"
                            target="_blank"
                            rel="noreferrer"
                            className={navLinkStyle}
                        >
                            Publications
                        </a>
                    </div>
                    <div className=" md:space-y-4">
                        <a
                            href="mailto:chegbe.christian@gmail.com"
                            className={navLinkStyle}
                        >
                            Contact
                        </a>
                    </div>
                </nav>

                <footer className="pb-16 text-center">
                    <p className="footer-text text-[11px] tracking-widest text-zinc-500 uppercase opacity-0">
                        Copyright © {new Date().getFullYear()} Christian Jacob
                    </p>
                </footer>
            </main>
        </div>
    );
};

export default Home;
